var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverageDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8015_803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9976 14.5809C15.2807 14.7933 15.5051 15.0744 15.6495 15.3976C15.7939 15.7208 15.8535 16.0755 15.8227 16.4282C15.792 16.7808 15.6719 17.1198 15.4737 17.4131C15.2756 17.7065 15.006 17.9445 14.6903 18.1047C14.3746 18.2649 14.0234 18.342 13.6696 18.3287C13.3159 18.3155 12.9714 18.2123 12.6686 18.0289C12.3658 17.8455 12.1147 17.588 11.9391 17.2807C11.7635 16.9733 11.6691 16.6263 11.6648 16.2723V9.99835",
    stroke: "#0B5ED7",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99929 9.99834H3.3329C2.89094 9.99834 2.46709 9.82277 2.15458 9.51026C1.84207 9.19775 1.6665 8.7739 1.6665 8.33194V4.16596C1.6665 3.72401 1.84207 3.30016 2.15458 2.98765C2.46709 2.67514 2.89094 2.49957 3.3329 2.49957H16.664C17.106 2.49957 17.5298 2.67514 17.8423 2.98765C18.1549 3.30016 18.3304 3.72401 18.3304 4.16596V8.33194C18.3304 8.7739 18.1549 9.19775 17.8423 9.51026C17.5298 9.82277 17.106 9.99834 16.664 9.99834H14.9976",
    stroke: "#0B5ED7",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99927 6.66559H14.9976",
    stroke: "#0B5ED7",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49919 12.9745C5.30297 13.1669 5.15736 13.4047 5.07531 13.6669C4.99326 13.9292 4.97732 14.2076 5.02891 14.4775C5.08049 14.7473 5.19801 15.0003 5.371 15.2137C5.54398 15.4272 5.76706 15.5946 6.02038 15.701C6.2737 15.8073 6.54939 15.8495 6.82292 15.8235C7.09645 15.7976 7.35932 15.7044 7.58814 15.5523C7.81695 15.4002 8.00461 15.1939 8.1344 14.9518C8.26419 14.7096 8.33209 14.4391 8.33205 14.1643V9.99835",
    stroke: "#0B5ED7",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8015_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageDetail);
export default __webpack_public_path__ + "static/media/coverage_detail.71ad3e33e0c28474b782c02b00d1108a.svg";
export { ForwardRef as ReactComponent };